module.exports = __webpack_public_path__ + "media/images/globe-58b94e3c.png";